import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';
import SectionHelp from '../templates/SectionHelp.mdx';

# Configure Page

This page is where you can Configure all of CanvasPro.

<SectionHelp />
